import { FETCH_ALL, FETCH, START_LOADING, END_LOADING } from '../constants/actionTypes';

const reducer = (state = { isLoading: true, events: [] }, action) => {
    switch (action.type) {
        case START_LOADING:
            return { ...state, isLoading: true };
        case END_LOADING:
            return { ...state, isLoading: false };
        case FETCH:
            return {...state, event: action.payload.data };
        case FETCH_ALL:
            return {
                ...state,
                events: action.payload.data,
                currentPage: action.payload.currentPage,
                numberOfPages: action.payload.numberOfPages
            };
        default:
            return state;
    }
};

export default reducer;